"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.handlePasskeyAuthenticationError = void 0;
const react_native_1 = require("@aws-amplify/react-native");
const handlePasskeyError_1 = require("./handlePasskeyError");
const passkeyError_1 = require("./passkeyError");
/**
 * Handle Passkey Authentication Errors
 *
 * @param err unknown
 * @returns PasskeyError
 */
const handlePasskeyAuthenticationError = (err) => {
    if (err instanceof passkeyError_1.PasskeyError) {
        return err;
    }
    if ((0, react_native_1.getIsNativeError)(err)) {
        // Passkey Retrieval Failed
        if (err.code === 'FAILED') {
            const { message, recoverySuggestion } = passkeyError_1.passkeyErrorMap[passkeyError_1.PasskeyErrorCode.PasskeyRetrievalFailed];
            return new passkeyError_1.PasskeyError({
                name: passkeyError_1.PasskeyErrorCode.PasskeyRetrievalFailed,
                message,
                recoverySuggestion,
                underlyingError: err,
            });
        }
        if (err.code === 'CANCELED') {
            const { message, recoverySuggestion } = passkeyError_1.passkeyErrorMap[passkeyError_1.PasskeyErrorCode.PasskeyAuthenticationCanceled];
            return new passkeyError_1.PasskeyError({
                name: passkeyError_1.PasskeyErrorCode.PasskeyAuthenticationCanceled,
                message,
                recoverySuggestion,
                underlyingError: err,
            });
        }
    }
    return (0, handlePasskeyError_1.handlePasskeyError)(err);
};
exports.handlePasskeyAuthenticationError = handlePasskeyAuthenticationError;
